import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { DARK_GRAY } from '../../../styles/constants/color';

const Button = styled.button`
  display: grid;
  align-items: center;
  width: 20px;
  height: 20px;
`;

const Stick = styled.div<{ active: boolean }>`
  width: 100%;
  height: 3px;
  background-color: ${DARK_GRAY};
  border-radius: 8px;
  opacity: 1;
  transition: all 0.3s ease-in-out;

  ${props =>
    props.active &&
    css`
      &:first-of-type {
        transform: translateY(6.6px) rotate(45deg);
      }

      &:nth-of-type(2) {
        opacity: 0;
      }

      &:last-of-type {
        transform: translateY(-6.6px) rotate(-45deg);
      }
    `}
`;

interface Props {
  active: boolean;
  onClick: () => void;
}

/**
 *  클릭시 메뉴버튼 -> 닫기버튼 혹은 닫기버튼 -> 메뉴버튼으로 바뀌는 이펙트가 있는 버튼 컴포넌트
 * @param {boolean} active 메뉴버튼 혹은 닫기버튼 상태
 * @param {function} onClick 클릭 이벤트 함수
 *  */
function DynamicMenuButton({ active, onClick }: Props): JSX.Element {
  return (
    <Button onClick={() => onClick()}>
      <Stick active={active} />
      <Stick active={active} />
      <Stick active={active} />
    </Button>
  );
}

export default DynamicMenuButton;
